export const TableHeaderMap = {
  workOrder: "Work Order Number",
  startDate: "Start Date and Time (UTC)",
  department: "Department",
  unitTouchTime: "Unit Touch Time (mins)",
  totalTouchTime: "Total Touch Time (mins)",
  partNumber: "Part Number",
  quantity: "Quantity"
};
